module.exports = __webpack_public_path__ + "static/Ryan_Dang_Resume-7900f109c1ce92f7eff6d1219f8c3f45.pdf";